import { render, staticRenderFns } from "./targetLearnerWidge.vue?vue&type=template&id=43bc441d&scoped=true"
import script from "./targetLearnerWidge.vue?vue&type=script&lang=js"
export * from "./targetLearnerWidge.vue?vue&type=script&lang=js"
import style0 from "./targetLearnerWidge.vue?vue&type=style&index=0&id=43bc441d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43bc441d",
  null
  
)

export default component.exports